/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  Component,
  OnInit
}                                from '@angular/core';

import { Logger                } from '@/util/logger';

@Component({
  standalone: false,
  templateUrl: 'help.component.html'
})

/**
 *
 * @class HelpComponent
 *
 * @brief give the user some help with keyboard controls etc.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class HelpComponent implements OnInit {

  /** standard constructor */
  constructor(
  ) {

  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[HelpComponent] init...');



  }

}

